import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../components/Login';
import Logout from '../components/Logout';
import Profile from '../pages/Akun/Profile';
import ChatHistories from '../pages/ChatHistory/chat/ChatHistories';
import ConcernPolicyForm from '../pages/Concern/ConcernPolicyForm';
import NewSyaratKetentuan from '../pages/Concern/NewSyaratKetentuan';
import HealthRecord from '../pages/HealthRecord/HealthRecord';
import Home from '../pages/Home';
import NotFoundPage from '../pages/NotFoundPage';
import AddressPage from '../pages/Prescription/AddressPage';
import CheckOutPage from '../pages/Prescription/CheckOutPage';
import EprescriptionDetail from '../pages/Prescription/EprescriptionDetail';
import EprescriptionList from '../pages/Prescription/EprescriptionList';
import EprescriptionOrder from '../pages/Prescription/EprescriptionOrder';
import ReferenceDetail from '../pages/Reference/ReferenceDetail';
import ReferenceList from '../pages/Reference/ReferenceList';
import SimpleVideoCallForm from '../pages/VideoCall/SimpleVideoCallForm';
import VideoCall from '../pages/VideoCall/VideoCall';
import VideoCallUI from '../pages/VideoCall/VideoCallUI';
import CheckoutTeleconsultation from '../pages/tanya-dokter/DetailTransaction/CheckoutTeleconsultation';
import PaymentMethodPage from '../pages/tanya-dokter/DetailTransaction/PaymentMethodPage';
import VoucherPage from '../pages/tanya-dokter/DetailTransaction/Voucher';
import Chat from '../pages/tanya-dokter/chat/Chat';
import ConnectingDoctor from '../pages/tanya-dokter/disclaimer/ConnectingDoctor';
import Disclaimer from '../pages/tanya-dokter/disclaimer/Disclaimer';
import ListDoctor from '../pages/tanya-dokter/list/ListDoctor';
import ScheduleConsultation from '../pages/tanya-dokter/list/ScheduleConsultation';
import PaymentSuccess from '../pages/tanya-dokter/DetailTransaction/PaymentSuccess';


interface RouterProps {
  isLoggedIn: boolean;
  userId: string | null;
  username: string | null;
  conversationID: string;
  conversationType: number;
}


const Router: React.FC<RouterProps> = ({
  isLoggedIn,
  userId,
  username,
  conversationID,
  conversationType,
}) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          isLoggedIn ? (
            <Navigate to="/home" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/login"
        element={
          isLoggedIn ? (
            <Navigate to="/home" replace />
          ) : (
            <Login />
          )
        }
      />
      <Route path="/logout" element={<Logout />} />
      <Route path="/home" element={<Home />} />
      <Route
        path="/chat/:conversationID/:token"
        element={
          isLoggedIn ? (
            <Chat/>
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/disclaimer/:practitionerRoleId"
        element={
          isLoggedIn ? (
            <Disclaimer />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/checkout-teleconsultation/:teleconsultationId"
        element={
          isLoggedIn ? (
            <CheckoutTeleconsultation />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/payment-success"
        element={
          isLoggedIn ? (
            <PaymentSuccess />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/payment-method/:teleconsultationId"
        element={
          isLoggedIn ? (
            <PaymentMethodPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/voucher/:teleconsultationId"
        element={
          isLoggedIn ? (
            <VoucherPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/connect-doctor/:teleconsultationId/:token?"
        element={
          isLoggedIn ? (
            <ConnectingDoctor />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription"
         element={
          isLoggedIn ? (
            <EprescriptionList />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/:prescriptionId"
         element={
          isLoggedIn ? (
            <EprescriptionDetail />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/:prescriptionId/order"
        element={
          isLoggedIn ? (
            <EprescriptionOrder />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/e-prescription/checkout/:prescriptionId/:token"
        element={
          isLoggedIn ? (
            <CheckOutPage />
          ) : (
            <Navigate to="/" replace />
          )
        } 
      />
      <Route
        path="/e-prescription/address-page/:prescriptionId/:token"
        element={
          isLoggedIn ? (
            <AddressPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/reference"
         element={
          isLoggedIn ? (
            <ReferenceList />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/reference/:referenceId"
         element={
          isLoggedIn ? (
            <ReferenceDetail />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/akun"
        element={
          isLoggedIn ? (
            <Profile />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/concerns/:token"
        element={
          isLoggedIn ? (
            <ConcernPolicyForm />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/new-syarat-dan-ketentuan"
        element={
          isLoggedIn ? (
            <NewSyaratKetentuan />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/chat-history"
         element={
          isLoggedIn ? (
            <ChatHistories 
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/health-record"
         element={
          isLoggedIn ? (
            <HealthRecord 
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/list-doctor"
         element={
          isLoggedIn ? (
            <ListDoctor 
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/schedule-consultation/:doctorId"
        element={
          isLoggedIn ? (
            <ScheduleConsultation />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/not-found"
          element={
          isLoggedIn ? (
            <NotFoundPage />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/video-call"
          element={
          isLoggedIn ? (
            <VideoCall />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/video-call-ui/:teleconsultationId/:token"
          element={
          isLoggedIn ? (
            <VideoCallUI />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
       <Route
        path="/form-video-call"
          element={
          isLoggedIn ? (
            <SimpleVideoCallForm />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />


    </Routes>
  );
};

export default Router;
